(function(){
function initKlw(root){
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var K_DONE = 'kl_roue_done', K_SEEN = 'kl_roue_seen', K_TEASER = 'kl_roue_teaser_off';
  function get(store, k){ try { return window[store].getItem(k); } catch (e) { return null; } }
  function set(store, k, v){ try { window[store].setItem(k, v); } catch (e) {} }
  var design = window.Shopify && window.Shopify.designMode;
  if (get('localStorage', K_DONE) && !design) return;

  var overlay = root.querySelector('[data-klw-overlay]');
  var teaser = root.querySelector('[data-klw-teaser]');
  var form = root.querySelector('[data-klw-page="form"]');
  var success = root.querySelector('[data-klw-page="success"]');
  var wheel = root.querySelector('[data-klw-wheel]');
  var email = root.querySelector('[data-klw-email]');
  var err = root.querySelector('[data-klw-err]');
  var btn = root.querySelector('[data-klw-submit]');
  var code = root.dataset.code;
  root.hidden = false;

  function showTeaser(){ if (!get('localStorage', K_DONE) && !get('sessionStorage', K_TEASER)) teaser.hidden = false; }
  function open(){
    overlay.hidden = false; teaser.hidden = true;
    set('localStorage', K_SEEN, '1');
    document.documentElement.style.overflow = 'hidden';
  }
  function close(){
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (get('localStorage', K_DONE)) root.hidden = true; else showTeaser();
  }

  root.querySelectorAll('[data-klw-close]').forEach(function(b){ b.addEventListener('click', close); });
  overlay.addEventListener('click', function(e){ if (e.target === overlay) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !overlay.hidden) close(); });
  root.querySelector('[data-klw-open]').addEventListener('click', open);
  root.querySelector('[data-klw-teaser-close]').addEventListener('click', function(){ teaser.hidden = true; set('sessionStorage', K_TEASER, '1'); });

  function angle(el){
    var m = getComputedStyle(el).transform;
    if (!m || m === 'none') return 0;
    var v = m.split('(')[1].split(')')[0].split(',');
    var a = Math.round(Math.atan2(parseFloat(v[1]), parseFloat(v[0])) * 180 / Math.PI);
    return (a + 360) % 360;
  }
  function spin(done){
    var from = angle(wheel);
    wheel.style.transform = 'rotate(' + from + 'deg)';
    wheel.classList.add('is-spinning');
    /* la case gagnante est centrée à 45° : elle passe sous le pointeur quand la roue est à 315° (+ tours) */
    var to = from + 360 * 4 + ((315 - from) % 360 + 360) % 360;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ wheel.style.transform = 'rotate(' + to + 'deg)'; }); });
    setTimeout(function(){
      var win = root.querySelector('[data-klw-win]');
      if (win && root.dataset.prize) win.textContent = root.dataset.prize;
      setTimeout(done, 1600);
    }, 4300);
  }
  function subscribe(addr){
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', addr);
    body.append('contact[tags]', root.dataset.tags || 'newsletter');
    return fetch('/contact#klw', { method: 'POST', body: body, credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function(r){ return r.ok && !/challenge/.test(r.url); })
      .catch(function(){ return false; });
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var addr = (email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)){ err.hidden = false; email.focus(); return; }
    err.hidden = true; btn.disabled = true; email.disabled = true;
    var saved = subscribe(addr);
    if (code) fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function(){});
    spin(function(){
      saved.then(function(ok){
        set('localStorage', K_DONE, '1');
        if (!ok || root.dataset.showCode === 'true') root.querySelector('[data-klw-code]').hidden = false;
        form.hidden = true; success.hidden = false;
      });
    });
  });

  if (design){
    document.addEventListener('shopify:section:select', function(e){ if (root.closest('[id^="shopify-section"]') && e.target.contains(root)) open(); });
    document.addEventListener('shopify:section:deselect', function(e){ if (e.target.contains(root)) close(); });
    showTeaser();
    return;
  }
  if (get('localStorage', K_SEEN)) { showTeaser(); return; }
  var delay = Math.max(0, parseInt(root.dataset.delay, 10) || 0) * 1000;
  setTimeout(function(){ if (overlay.hidden && !get('localStorage', K_DONE)) open(); }, delay);
}
function boot(){ document.querySelectorAll('[data-klw]').forEach(initKlw); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
